import {useMemo} from 'react';

import {NoteDay} from 'notebook/util/NoteUtilConstants';

/**
 * Creates a lookup map for efficient batch operations between provenanceUuid and cid.
 * Useful for performance optimization with large notebooks.
 *
 * @param note The note containing the days to map
 * @returns A Map with provenanceUuid as keys and cid as values
 */
export function createProvenanceUuidToCidMap(days: Array<NoteDay>): Map<string, string> {
  const map = new Map<string, string>();

  days.forEach((day) => {
    if (day.provenanceUuid && day.cid) {
      map.set(day.provenanceUuid, day.cid);
    }
  });

  return map;
}

/**
 * Hook for memoized provenance UUID to CID mapping.
 * Automatically recalculates only when the days array changes.
 * Useful for large notebooks with many sections to avoid repeated calculations.
 *
 * @param note The note containing the days to map
 * @returns A memoized Map with provenanceUuid as keys and cid as values
 */
export function useProvenanceUuidToCidMap(days: Array<NoteDay>): Map<string, string> {
  return useMemo(() => createProvenanceUuidToCidMap(days), [days]);
}
